import { render, staticRenderFns } from "./InsCmsCat13.vue?vue&type=template&id=23b4fd4e&scoped=true&"
import script from "./InsCmsCat13.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat13.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat13.vue?vue&type=style&index=0&id=23b4fd4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4fd4e",
  null
  
)

export default component.exports